import React, {Component} from 'react';
import {
    Route,
    Link,
    NavLink as RRDLink,
    Redirect,
    Switch
} from "react-router-dom";
import {
    NavLink,
    Navbar,
    NavbarBrand,
    Nav,
    NavItem,
    UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    // Alert,
    NavbarToggler,
    Collapse,
    Spinner
} from 'reactstrap';
import PropTypes from 'prop-types';
import IconContainer from './commonComponents/iconContainer/IconContainer';
import _ from 'lodash';
import {ROLES, SUB_ROLES, NO_SUB_ROLES} from '../reducers/account/role';
import {Utils} from '../utils/utils';
import {StorageApi} from '../utils/storageApi';
import {sharedLabelsPath} from '../reducers/common/localization';
import './App.css';
import Logo from './Logo.png';
import LogoSM from './logo-sm.png';
import Mantra from './mantra.png';
import HomePage from './commonComponents/homePage/HomePage.container';
import UserSubRoleMissingModal from './commonComponents/userSubRoleMissingModal/UserSubRoleMissingModal.container';
import OrgPermissionsMissingModal
    from './commonComponents/orgPermissionsMissingModal/OrgPermissionsMissingModal.container';
import PageNotFoundComponent from './commonComponents/pageNotFoundComponent/PageNotFoundComponent.container';
import ServerErrorComponent from './commonComponents/serverErrorComponent/ServerErrorComponent.container';
import HelpComponent from './commonComponents/helpComponent/HelpComponent.container';
import PaymentComponent from './commonComponents/paymentComponent/PaymentComponent.container';
import NavBarWithRoles from './navBarWithRoles/NavBarWithRoles.container';
import LanguageSelector from "./languageSelector/LanguageSelector.container";
import OAuthUserLogin from './accountManagement/oauthUserLogin/OAuthUserLogin.container';
import Login from './accountManagement/login/Login.container';
import ActivateUserAccount from './accountManagement/activateUserAccount/ActivateUserAccount.container';
import RestoreAccount from "./accountManagement/restoreAccount/RestoreAccount.container";
import ResetPassword from "./accountManagement/resetPassword/ResetPassword.container";
import ChangeEmailFinish from "./accountManagement/changeEmailFinish/ChangeEmailFinish.container";
import ResendActivation from './accountManagement/resendActivation/ResendActivation.container';
import RegisterApplicant from "./accountManagement/registerApplicant/RegisterApplicant.container";
import RegisterInvitedApplicant from "./accountManagement/registerInvitedApplicant/RegisterInvitedApplicant.container";
import AccountManagementComponent
    from './accountManagement/accountManagementComponent/AccountManagementComponent.container';
import OrgsList from './organizationManagement/orgsList/OrgsList.container';
import RegisterOrg from './organizationManagement/registerOrg/RegisterOrg.container';
import StaffList from './staffMemberManagement/staffList/StaffList.container';
import InsertAccreditation from './accreditationManagement/insertAccreditation/InsertAccreditation.container';
import ValidateAccreditation from './accreditationManagement/validateAccreditation/ValidateAccreditation.container';
import ReviewAccreditationRejectedByValidator
    from './accreditationManagement/reviewAccreditation/ReviewAccreditationRejectedByValidator.container';
import ReviewAccreditationRejectedByApplicant
    from './accreditationManagement/reviewAccreditation/ReviewAccreditationRejectedByApplicant.container';
import AccreditationsListForValidate
    from "./accreditationManagement/accreditationsList/AccreditationsListForValidate.container";
import RejectedAccreditationsManagementComponent
    from "./accreditationManagement/rejectedAccreditationsManagementComponent/RejectedAccreditationsManagementComponent.container";
import AccreditationGroupsList from "./staffMemberManagement/AccreditationGroupsList/AccreditationGroupsList.container";
import AccreditationGroupDetails
    from "./staffMemberManagement/AccreditationGroupDetails/AccreditationGroupDetails.container";
import BulkJobsList from "./accreditationManagement/bulkJobsList/BulkJobsList.container";
import OrgDetails from "./organizationManagement/orgDetails/OrgDetails.container";
import BulkFileFormatDetails from "./commonComponents/bulkFileFormatDetails/BulkFileFormatDetails.container";
import OrgsToValidateList from "./organizationManagement/orgsListToValidate/OrgsToValidateList.container";
import ValidateOrg from "./organizationManagement/orgModal/validateOrg/ValidateOrg.container";
import DepartmentsList from "./staffMemberManagement/departmentsList/DepartmentsList.container";
import DepartmentDetails from "./staffMemberManagement/departmentDetails/DepartmentDetails.container";
import CertifiedAccreditationsList
    from './applicantAccreditationsManagement/certifiedAccreditationsList/CertifiedAccreditationsList.container';
import PendingAccreditationsList
    from './applicantAccreditationsManagement/pendingAccreditationsList/PendingAccreditationsList.container';
import ValidatePendingAccreditation
    from './applicantAccreditationsManagement/validatePendingAccreditation/ValidatePendingAccreditation.container';
import VIDsList from './applicantAccreditationsManagement/VIDsList/VIDsList.container';
import RegisterOrgByAnchor from "./organizationManagement/registerOrgByAnchor/RegisterOrgByAnchor.container";
import CreateAccount from "./accountManagement/createAccount/CreateAccount.container";
import OrgSettings from "./organizationManagement/orgSettings/OrgSettings.container";
import CredentialsVerificationRequest
    from "./consentManagement/credentialsVerificationRequest/CredentialsVerificationRequest.container";
import PendingConsentsList from "./consentManagement/consentsList/pendingConsentsList/PendingConsentsList.container";
import ApproveConsentAfterRequest
    from "./consentManagement/approveConsentAfterRequest/ApproveConsentAfterRequest.container";
import ConsentRequestsList from './organizationConsentManagement/consentRequestsList/ConsentRequestsList.container';
import PriorConsentsList from "./consentManagement/consentsList/priorConsentsList/PriorConsentsList.container";
import AddPriorConsent from './consentManagement/priorConsentDetails/AddPriorConsent.container';
import EditPriorConsent from './consentManagement/priorConsentDetails/EditPriorConsent.container';
import HistoryConsentsList from "./consentManagement/consentsList/historyConsentsList/HistoryConsentsList.container";
import SelfStudyList from "./selfStudyManagement/selfStudyList/SelfStudyList.container";
import SelfStudyAdd from "./selfStudyManagement/selfStudyDetails/SelfStudyAdd.container";
import SelfStudyEdit from "./selfStudyManagement/selfStudyDetails/SelfStudyEdit.container";
import BulkConsentRequestsList from "./consentManagement/bulkConsentRequestsList/BulkConsentRequestsList.container";
import CollapseWithArrow from './commonComponents/collapseWithArrow/CollapseWithArrow';
import CreateAccreditationRequest
    from "./applicantAccreditationsManagement/createAccreditationRequest/CreateAccreditationRequest.container";
import AccreditationRequestsList
    from "./applicantAccreditationsManagement/accreditationRequestsList/AccreditationRequestsList.conatiner";
import EditAccreditationRequest
    from "./applicantAccreditationsManagement/editAccreditationRequest/EditAccreditationRequest.container";
import PendingAccreditationRequestsByDomainsList
    from "./accreditationManagement/accreditationRequestsByDomainsList/PendingAccreditationRequestsByDomainsList.container";
import AccreditationRequestsByGroupList
    from "./accreditationManagement/accreditationRequestsByGroupList/AccreditationRequestsByGroupList.container";
import PendingAccreditationRequestsList
    from "./accreditationManagement/pendingAccreditationRequestsList/PendingAccreditationRequestsList.container";
import ProcessAccreditationRequest
    from "./accreditationManagement/processAccreditationRequest/ProcessAccreditationRequest.container";
import GroupsManagementComponent from "./staffMemberManagement/groupsManagement/GroupsManagementComponent.container";
import CurrentConsents from "./consentManagement/currentConsents/CurrentConsents";
import AnchorSecurityComponent from './securityManagement/anchorSecurityComponent/AnchorSecurityComponent.container';
import InsertorSecurityComponent
    from './securityManagement/insertorSecurityComponent/InsertorSecurityComponent.container';
import AdminSecurityComponent from './securityManagement/adminSecurityComponent/AdminSecurityComponent.container';
import OrgsPaymentsList from "./organizationManagement/orgsPaymentsList/OrgsPaymentsList.container";
import OrgPaymentsDetails from "./organizationManagement/orgPaymentsDetails/OrgPaymentsDetails.container";
import AssistantsList from "./assistantsManagement/assistantsList/AssistantsList.container";
import AddAssistantComponent from "./assistantsManagement/addAssistantComponent/AddAssistantComponent.container";
import BusinessAmbassadorsList
    from "./businessAmbassadorsManagement/businessAmbassadorsList/BusinessAmbassadorsList.container";
import AddBusinessAmbassador
    from "./businessAmbassadorsManagement/businessAmbassadorDetails/AddBusinessAmbassador.container";
import EditBusinessAmbassador
    from "./businessAmbassadorsManagement/businessAmbassadorDetails/EditBusinessAmbassador.container";
import CommissionsList from "./paymentManagement/commissionsList/CommissionsList.container";
import AddCommission from "./paymentManagement/commissionDetails/AddCommission.container";
import EditCommission from "./paymentManagement/commissionDetails/EditCommission.container";
import DuePaymentsComponent
    from './paymentManagement/systemPaymentComponent/duePaymentsComponent/DuePaymentsComponent.container';
import PaymentsHistoryComponent
    from './paymentManagement/systemPaymentComponent/paymentsHistoryComponent/PaymentsHistoryComponent.container';
import ValidatedDomainsList from './accreditationManagement/validatedDomainsList/ValidatedDomainsList.container';

class App extends Component {
    constructor(props) {
        super(props);

        this.redirectPathAfterLogin = null;

        this.state = {
            collapsed: false
        }
    }

    componentWillMount() {
        if (this.props.location.pathname === '/activation' || this.props.location.pathname === '/resetPassword' || this.props.location.pathname === '/changeEmail' || this.props.location.pathname === '/applicant-registration') {
            this.onLogOut();
        } else if (StorageApi.isLoginTokenAvailable()) {
            this.props.onSetUser();
        }
        if (this.props.location.pathname !== '/activation' && this.props.location.pathname !== '/resetPassword' && this.props.location.pathname !== '/changeEmail' && this.props.location.pathname !== '/applicant-registration' && this.props.location.pathname !== "/login" && this.props.location.pathname !== "/login/restore") {
            this.redirectPathAfterLogin = this.props.location.pathname;
        }
        this.unlisten = this.props.history.listen((location) => {
            if (location.pathname !== '/login' && location.pathname !== '/activation' && location.pathname !== '/resetPassword' && location.pathname !== '/applicant-registration') {
                if (this.props.subRole === SUB_ROLES.ANCHOR) {
                    this.props.onGetOrgBalance();
                }
                let userId = StorageApi.getUserId();
                if (!_.isNil(userId) && !_.isNil(this.props.userId) && this.props.userId !== userId) {
                    this.refreshPage();
                }
            }
            if (location.pathname === '/activation' || location.pathname === '/resetPassword' || location.pathname === '/applicant-registration') {
                this.onLogOut();
            }
        });
    }

    componentWillUnmount() {
        this.unlisten();
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.isForbidden) {
            this.refreshPage();
        }

        if (nextProps.isAuthorised !== this.props.isAuthorised) {
            this.setState({collapsed: false});
        }
    }

    redirectToMainPage = () => {
        this.props.history.push("/home");
    };

    refreshPage = () => {
        this.props.history.go(0);
        this.props.onRefreshForbidden();
    };

    render() {
        if (this.props.location.pathname === "/oauth/authorize") {
            return <div className="App">
                <Navbar color="dark" dark expand="md">
                    <NavbarBrand tag={Link} to={this.props.isAuthorised ? "/home" : "/login"} target="_blank">
                        <img className="logo" alt="" src={Logo}
                             title={_.get(this.props.translation, 'main.home_page_label')}/>
                    </NavbarBrand>
                    <Nav className="ml-auto">
                        <LanguageSelector/>
                    </Nav>
                    {this.renderMantra()}
                </Navbar>
                <OAuthUserLogin location={this.props.location}/>
            </div>
        }
        //TODO: check & fix all components layouts
        //TODO: fix incorrect using of bootstrap layout (the content should not get out of the container)
        if (this.props.isServerError) {
            return <div className="content-container">
                <ServerErrorComponent/>
            </div>;
        }

        if (this.props.isForbidden || _.isNil(this.props.translation)) {
            return null;
        }

        if (this.props.loadingUserData || this.props.loadingOrganizationData || this.props.loadingTranslation) {
            return <div className="App">
                <Navbar color="dark" dark className="navbar-expand-custom">
                    <NavbarBrand tag={Link} to={this.props.isAuthorised ? "/home" : "/login"}>
                        <img className="logo" alt="" src={Logo}
                             title={_.get(this.props.translation, 'main.home_page_label')}/>
                        <img className="logo-sm" alt="" src={LogoSM}
                             title={_.get(this.props.translation, 'main.home_page_label')}/>
                    </NavbarBrand>
                    <Nav className="ml-auto">
                        <LanguageSelector/>
                    </Nav>
                    {this.renderMantra()}
                </Navbar>
                <div className="loading-app-container">
                    <Spinner color="secondary"
                             title={_.get(this.props.translation, sharedLabelsPath.fetching_message)}/>
                </div>
            </div>
        }


        return (
            <div className="App">
                <Navbar color="dark" dark className="navbar-expand-custom">
                    <NavbarBrand tag={Link} to={this.props.isAuthorised ? "/home" : "/login"}>
                        <img className="logo" alt="" src={Logo}
                             title={_.get(this.props.translation, 'main.home_page_label')}/>
                        <img className="logo-sm" alt="" src={LogoSM}
                             title={_.get(this.props.translation, 'main.home_page_label')}/>
                    </NavbarBrand>
                    <Nav className="ml-auto language-select-with-collapse">
                        <LanguageSelector/>
                    </Nav>
                    <NavbarToggler onClick={this.handleNavbarTogglerClick}/>
                    {this.renderCollapse()}
                    {this.renderMantra()}
                </Navbar>
                <NavBarWithRoles hidden={!this.props.isAuthorised || this.props.location.pathname === "/home"}/>

                <Switch key="router-switch">
                    <Route exact path="/login" render={this.renderLoginView('login')}/>
                    <Route exact path="/activation" render={this.renderActivationView}/>
                    <Route exact path="/login/restore" render={this.renderLoginView('restore')}/>
                    <Route exact path="/resetPassword" render={this.renderResetPasswordView}/>
                    <Route exact path="/changeEmail" render={this.renderChangeEmailView}/>
                    <Route exact path="/resend-activation" render={this.renderLoginView('resend-activation')}/>
                    <Route exact path="/account-creation" render={this.renderLoginView('account-creation')}/>
                    <Route exact path="/applicant-registration" render={this.renderRegistrationView}/>
                    <Route exact path="/company-registration" render={this.renderLoginView('company-registration')}/>
                    <Route exact path="/support" render={this.renderHelpView}/>
                    {this.getRoutes()}
                    <Route path="/" render={this.renderAuthorisedView()}/>
                </Switch>

                <UserSubRoleMissingModal onSubmit={this.redirectToMainPage}
                                         updateSubRolesOnly={this.props.location.pathname === "/home"}/>
                <OrgPermissionsMissingModal onSubmit={this.redirectToMainPage}/>

            </div>
        );
    }

    renderMantra = () => {
        let className = 'mantra-container';
        if (this.props.isAuthorised && this.props.location.pathname !== "/home" && this.props.location.pathname !== "/login") {
            className += ' hidden';
        }

        return (
            <div className={className}>
                <img className="mantra" alt="" src={Mantra}/>
            </div>
        );
    };

    renderCollapse = () => {
        return (
            <Collapse className="app-collapse" isOpen={this.state.collapsed} navbar>
                {this.renderNavs()}
            </Collapse>
        )
    };

    renderNavs = () => {
        return (
            <div className='nav-container'>
                <Nav className="mr-auto" hidden={!this.props.isAuthorised || this.props.location.pathname === "/home"}>
                    {this.getNavItems()}
                </Nav>
                <div className="nav-container-right">
                    <Nav className="nav-with-dropdown" hidden={this.props.isAuthorised}>
                        <NavItem>
                            <NavLink tag={Link} to="/support" onClick={this.closeCollapse}>
                                {_.get(this.props.translation, 'main.help_label')}
                            </NavLink>
                        </NavItem>
                    </Nav>
                    <Nav className="nav-with-nav-items" hidden={this.props.isAuthorised}>
                        <NavItem>
                            <NavLink tag={Link} to="/support" onClick={this.closeCollapse}>
                                {_.get(this.props.translation, 'main.help_label')}
                            </NavLink>
                        </NavItem>
                    </Nav>
                    {this.renderUserMenu()}
                    <Nav className="ml-auto language-select">
                        <LanguageSelector/>
                    </Nav>
                </div>
            </div>
        );
    };

    renderUserMenu = () => {
        return [
            <Nav key="nav-with-dropdown" className="nav-with-dropdown" hidden={!this.props.isAuthorised}>
                <UncontrolledDropdown className="account-dropdown" nav inNavbar>
                    <DropdownToggle nav caret title={this.props.userEmail}>
                        <IconContainer className="person-icon" icon="person"/>
                        <span className="user-email">{this.props.userEmail}</span>
                    </DropdownToggle>
                    <DropdownMenu right>
                        <DropdownItem key='account' tag={Link} to="/account">
                            {_.get(this.props.translation, 'account_management.label')}
                        </DropdownItem>
                        <DropdownItem tag="a" target='_blank' href="http://brainchainmission.org/user-forum-2">
                            {_.get(this.props.translation, 'main.help_label')}
                        </DropdownItem>
                        <DropdownItem divider/>
                        <DropdownItem onClick={this.onLogOut} tag={Link} to="/login">
                            {_.get(this.props.translation, 'main.log_out_button')}
                        </DropdownItem>
                    </DropdownMenu>
                </UncontrolledDropdown>
            </Nav>,
            <Nav key="nav-with-nav-items" className="nav-with-nav-items" hidden={!this.props.isAuthorised}>
                <div className="nav-items-divider"/>
                <NavItem>
                    <NavLink tag={RRDLink} to="/account" activeClassName="active" onClick={this.closeCollapse}>
                        {_.get(this.props.translation, 'account_management.label')}
                    </NavLink>
                </NavItem>
                <NavItem>
                    <NavLink target="_blank" href="http://brainchainmission.org/user-forum-2"
                             onClick={this.closeCollapse}>
                        {_.get(this.props.translation, 'main.help_label')}
                    </NavLink>
                </NavItem>
                <div className="nav-items-divider"/>
                <NavItem>
                    <NavLink onClick={this.onLogOut} tag={Link} to="/login">
                        {_.get(this.props.translation, 'main.log_out_button')}
                    </NavLink>
                </NavItem>
            </Nav>
        ]
    };

    getNavItems = () => {
        let params = this.getNavItemsParams();
        if (_.isNil(params)) {
            return null;
        }

        let result = [];

        params.forEach((elem, id) => {
            switch (elem.type) {
                case "DROPDOWN":
                    if (elem.hidden) {
                        break;
                    }
                    result.push(
                        <UncontrolledDropdown className="dropdown-in-nav" nav inNavbar key={"dropdown" + id}
                                              setActiveFromChild>
                            <DropdownToggle nav caret>
                                {elem.title}
                            </DropdownToggle>
                            <DropdownMenu right>
                                {_.map(elem.children, (child, childId) => {
                                    if (child.hidden) {
                                        return null;
                                    }
                                    return (
                                        <DropdownItem key={childId} tag={RRDLink} to={child.to}
                                                      active={this.props.location.pathname === child.to}>
                                            {child.title}
                                        </DropdownItem>
                                    );
                                })}
                            </DropdownMenu>
                        </UncontrolledDropdown>
                    );

                    result.push(
                        <CollapseWithArrow
                            title={elem.title}
                            className="nav-item-with-collapse"
                            key={"collapse" + id}
                        >
                            {_.map(elem.children, (child, childId) => {
                                if (child.hidden) {
                                    return null;
                                }
                                return (
                                    <NavItem key={childId}>
                                        <NavLink tag={RRDLink} to={child.to} activeClassName="active"
                                                 onClick={this.closeCollapse}>
                                            {child.title}
                                        </NavLink>
                                    </NavItem>
                                );
                            })}
                        </CollapseWithArrow>
                    );

                    break;

                case "NAV":
                    if (!elem.hidden) {
                        result.push(
                            <NavItem key={id}>
                                <NavLink tag={RRDLink} to={elem.to} activeClassName="active"
                                         onClick={this.closeCollapse}>
                                    {elem.title}
                                </NavLink>
                            </NavItem>
                        );
                    }
                    break;

                default:
                    break;
            }
        });

        return result;
    };

    getNavItemsParams = () => {
        switch (this.props.role) {
            case ROLES.SYS_ADMIN:
                return [
                    {
                        type: "DROPDOWN",
                        title: _.get(this.props.translation, 'main.organizations_select_button'),
                        children: [
                            {
                                to: "/register-org",
                                title: _.get(this.props.translation, 'main.register_org_shirt_page_button'),
                                hidden: !_.includes(this.props.subRoles, SUB_ROLES.FA) && !_.includes(this.props.subRoles, SUB_ROLES.ROOT)
                            },
                            {
                                to: "/organizations",
                                title: _.get(this.props.translation, 'main.orgs_shirt_page_button')
                            },
                            {
                                to: "/validate-organizations",
                                title: _.get(this.props.translation, 'main.validate_organizations_shirt_page_button')
                            },
                            {
                                to: "/security",
                                title: _.get(this.props.translation, 'main.security_page_button'),
                                hidden: !this.props.subRoles.includes(SUB_ROLES.ROOT) && !this.props.subRoles.includes(SUB_ROLES.PA)
                            }
                        ]
                    },
                    {
                        type: "DROPDOWN",
                        title: _.get(this.props.translation, 'main.domains_page_button'),
                        hidden: !this.props.subRoles.includes(SUB_ROLES.ROOT) && !this.props.subRoles.includes(SUB_ROLES.PA),
                        children: [
                            {
                                to: "/validated-domains",
                                title: _.get(this.props.translation, 'main.validated_accreditation_requests_by_domain_shirt_page_button')
                            },
                            {
                                to: "/pending-accreditation-requests-by-domains",
                                title: _.get(this.props.translation, 'main.pending_accreditation_requests_by_domain_shirt_page_button')
                            }
                        ]
                    },
                    {
                        type: "DROPDOWN",
                        title: _.get(this.props.translation, 'main.assistants_page_button'),
                        hidden: !this.props.subRoles.includes(SUB_ROLES.ROOT),
                        children: [
                            {
                                type: "NAV",
                                to: "/assistants-management",
                                title: _.get(this.props.translation, 'main.assistants_page_button'),
                                hidden: !this.props.subRoles.includes(SUB_ROLES.ROOT)
                            },
                            {
                                type: "NAV",
                                to: "/business-ambassadors",
                                title: _.get(this.props.translation, 'main.business_ambassadors_page_button'),
                                hidden: !this.props.subRoles.includes(SUB_ROLES.ROOT)
                            }
                        ]
                    },
                    {
                        type: "DROPDOWN",
                        title: _.get(this.props.translation, 'main.system_payment_select_button'),
                        hidden: !this.props.subRoles.includes(SUB_ROLES.ROOT) && !this.props.subRoles.includes(SUB_ROLES.FA),
                        children: [
                            {
                                to: "/commissions",
                                title: _.get(this.props.translation, 'main.commissions_list_page_button'),
                                hidden: !this.props.subRoles.includes(SUB_ROLES.ROOT)
                            },
                            {
                                to: "/organizations-payments",
                                title: _.get(this.props.translation, 'main.orgs_payments_page_button'),
                                hidden: !this.props.subRoles.includes(SUB_ROLES.ROOT) && !this.props.subRoles.includes(SUB_ROLES.FA)
                            },
                            {
                                to: "/due-payments",
                                title: _.get(this.props.translation, 'main.due_payments_page_button')
                            },
                            {
                                to: "/payments-history",
                                title: _.get(this.props.translation, 'main.payments_history_shirt_page_button')
                            }
                        ]
                    }
                ];

            case ROLES.EMPLOYEE:
                switch (this.props.subRole) {
                    case NO_SUB_ROLES:
                        return null;

                    case SUB_ROLES.ANCHOR:
                        return [
                            {
                                type: "DROPDOWN",
                                title: _.get(this.props.translation, 'main.organization_select_button'),
                                children: [
                                    {
                                        to: "/org-settings",
                                        title: _.get(this.props.translation, 'main.org_management_button')
                                    },
                                    {
                                        to: "/organization-staff",
                                        title: _.get(this.props.translation, 'main.staff_members_page_button')
                                    },
                                    {
                                        to: "/payment",
                                        title: _.get(this.props.translation, 'main.payment_label')
                                    },
                                    {
                                        to: "/groups-management",
                                        title: _.get(this.props.translation, 'main.departments_page_button'),
                                        hidden: _.isNil(this.props.orgPermissions) || this.props.orgPermissions.hasIVs
                                    },
                                    {
                                        to: "/groups-management",
                                        title: _.get(this.props.translation, 'main.groups_management_page_button'),
                                        hidden: _.isNil(this.props.orgPermissions) || !this.props.orgPermissions.hasIVs
                                    },
                                    {
                                        to: "/security",
                                        title: _.get(this.props.translation, 'main.security_page_button'),
                                        hidden: _.isNil(this.props.orgPermissions) || !this.props.orgPermissions.hasIVs
                                    }
                                ]
                            },
                            {
                                type: "NAV",
                                to: "/accreditation-requests-by-group",
                                title: _.get(this.props.translation, 'main.accreditation_requests_list_page_button'),
                                hidden: _.isNil(this.props.orgPermissions) || !this.props.orgPermissions.hasIVs
                            }
                        ];

                    case SUB_ROLES.INSERTER:
                        return [
                            {
                                type: "DROPDOWN",
                                title: _.get(this.props.translation, 'main.inserter_accreditations_select_button'),
                                children: [
                                    {
                                        to: "/insert-accreditation",
                                        title: _.get(this.props.translation, 'main.insert_accreditation_shirt_page_button')
                                    },
                                    {
                                        to: "/review-accreditations",
                                        title: _.get(this.props.translation, 'main.review_accreditations_shirt_page_button')
                                    },
                                    {
                                        to: "/bulk-accreditations-upload",
                                        title: _.get(this.props.translation, 'main.bulk_jobs_list_shirt_page_button')
                                    },
                                    {
                                        to: "/pending-accreditation-requests",
                                        title: _.get(this.props.translation, 'main.pending_accreditation_requests_page_button')
                                    },
                                    {
                                        to: "/security",
                                        title: _.get(this.props.translation, 'main.security_page_button')
                                    }
                                ]
                            }
                        ];

                    case SUB_ROLES.VALIDATOR:
                        return [
                            {
                                type: "NAV",
                                to: "/validate-accreditations",
                                title: _.get(this.props.translation, 'main.validate_accreditations_page_button')
                            }
                        ];

                    case SUB_ROLES.BO:
                        return [
                            {
                                type: "NAV",
                                to: "/consent-requests",
                                title: _.get(this.props.translation, 'main.consent_requests_page_button')
                            },
                            {
                                type: "NAV",
                                to: "/bulk-consent-requests",
                                title: _.get(this.props.translation, 'main.bulk_consent_requests_page_button')
                            }
                        ];

                    case SUB_ROLES.HM:
                        return [
                            {
                                type: "NAV",
                                to: "/credentials-verification-request",
                                title: _.get(this.props.translation, 'main.verification_request_page_button')
                            },
                            {
                                type: "NAV",
                                to: "/consent-requests",
                                title: _.get(this.props.translation, 'main.consent_requests_page_button')
                            },
                            {
                                type: "NAV",
                                to: "/bulk-consent-requests",
                                title: _.get(this.props.translation, 'main.bulk_consent_requests_page_button')
                            }
                        ];

                    default:
                        break;
                }
                break;

            case ROLES.APPLICANT:
                return [
                    {
                        type: "DROPDOWN",
                        title: _.get(this.props.translation, 'main.applicant_accreditations_select_button'),
                        children: [
                            {
                                to: "/certified-accreditations",
                                title: _.get(this.props.translation, 'main.certified_accreditations_page_button')
                            },
                            {
                                to: "/pending-accreditations",
                                title: _.get(this.props.translation, 'main.pending_accreditations_page_button')
                            },
                            {
                                to: "/verified-identities",
                                title: _.get(this.props.translation, 'main.vids_page_button')
                            },
                            {
                                to: "/accreditation-requests-list",
                                title: _.get(this.props.translation, 'main.accreditation_requests_list_page_button')
                            }
                        ]
                    },
                    {
                        type: "DROPDOWN",
                        title: _.get(this.props.translation, 'main.applicant_consents_select_button'),
                        children: [
                            {
                                to: "/pending-consents",
                                title: _.get(this.props.translation, 'main.pending_consents_page_button')
                            },
                            {
                                to: "/active-consents",
                                title: _.get(this.props.translation, 'main.active_consents_page_button')
                            },
                            {
                                to: "/prior-consents",
                                title: _.get(this.props.translation, 'main.prior_consents_page_button')
                            },
                            {
                                to: "/consents-history",
                                title: _.get(this.props.translation, 'main.consents_history_page_button')
                            }
                        ]
                    },
                    {
                        type: "NAV",
                        to: "/self-study-books",
                        title: _.get(this.props.translation, 'main.self_study_books_page_button')
                    }
                ];

            default:
                break;
        }
    };

    getCommonRoutes = () => {
        return [
            <Route
                key="home"
                exact
                path="/home"
                render={this.renderAuthorisedView('home')}
            />,
            <Route
                key="account"
                exact
                path="/account"
                render={this.renderAuthorisedView("account")}
            />
        ];
    };

    getRoutes = () => {
        switch (this.props.role) {
            case ROLES.SYS_ADMIN:
                return [
                    <Route
                        key="organizations"
                        exact
                        path="/organizations"
                        render={this.renderAuthorisedView("organizations")}
                    />,
                    <Route
                        key="validate-organizations"
                        exact
                        path="/validate-organizations"
                        render={this.renderAuthorisedView("validate-organizations")}
                    />,
                    !_.includes(this.props.subRoles, SUB_ROLES.FA) && !_.includes(this.props.subRoles, SUB_ROLES.ROOT) ? null :
                        <Route
                            key="register-org"
                            exact
                            path="/register-org"
                            render={this.renderAuthorisedView("register-org")}
                        />,
                    <Route
                        key="organization"
                        exact
                        path="/organization"
                        render={this.renderAuthorisedView("organization")}
                    />,
                    <Route
                        key="validate-organization"
                        exact
                        path="/validate-organization"
                        render={this.renderAuthorisedView("validate-organization")}
                    />,
                    /*!this.props.subRoles.includes(SUB_ROLES.ROOT) && !this.props.subRoles.includes(SUB_ROLES.PA) ? null :
                        <Route
                            key="validated-accreditation-requests-by-domains"
                            exact
                            path="/validated-accreditation-requests-by-domains"
                            render={this.renderAuthorisedView("validated-accreditation-requests-by-domains")}
                        />,*/
                    !this.props.subRoles.includes(SUB_ROLES.ROOT) && !this.props.subRoles.includes(SUB_ROLES.PA) ? null :
                        <Route
                            key="pending-accreditation-requests-by-domains"
                            exact
                            path="/pending-accreditation-requests-by-domains"
                            render={this.renderAuthorisedView("pending-accreditation-requests-by-domains")}
                        />,
                    !this.props.subRoles.includes(SUB_ROLES.ROOT) && !this.props.subRoles.includes(SUB_ROLES.PA) ? null :
                        <Route
                            key="security"
                            exact
                            path="/security"
                            render={this.renderAuthorisedView("security")}
                        />,
                    !this.props.subRoles.includes(SUB_ROLES.ROOT) && !this.props.subRoles.includes(SUB_ROLES.FA) ? null :
                        <Route
                            key="organizations-payments"
                            exact
                            path="/organizations-payments"
                            render={this.renderAuthorisedView("organizations-payments")}
                        />,
                    !this.props.subRoles.includes(SUB_ROLES.ROOT) && !this.props.subRoles.includes(SUB_ROLES.FA) ? null :
                        <Route
                            key="organization-payments"
                            exact
                            path="/organization-payments"
                            render={this.renderAuthorisedView("organization-payments")}
                        />,
                    !this.props.subRoles.includes(SUB_ROLES.ROOT) ? null :
                        <Route
                            key="assistants-management"
                            exact
                            path="/assistants-management"
                            render={this.renderAuthorisedView("assistants-management")}
                        />,
                    !this.props.subRoles.includes(SUB_ROLES.ROOT) ? null :
                        <Route
                            key="add-assistant"
                            exact
                            path="/add-assistant"
                            render={this.renderAuthorisedView("add-assistant")}
                        />,
                    !this.props.subRoles.includes(SUB_ROLES.ROOT) ? null :
                        <Route
                            key="business-ambassadors"
                            exact
                            path="/business-ambassadors"
                            render={this.renderAuthorisedView("business-ambassadors")}
                        />,
                    !this.props.subRoles.includes(SUB_ROLES.ROOT) ? null :
                        <Route
                            key="add-business-ambassador"
                            exact
                            path="/add-business-ambassador"
                            render={this.renderAuthorisedView("add-business-ambassador")}
                        />,
                    !this.props.subRoles.includes(SUB_ROLES.ROOT) ? null :
                        <Route
                            key="edit-business-ambassador"
                            exact
                            path="/edit-business-ambassador"
                            render={this.renderAuthorisedView("edit-business-ambassador")}
                        />,
                    !this.props.subRoles.includes(SUB_ROLES.ROOT) ? null :
                        <Route
                            key="commissions"
                            exact
                            path="/commissions"
                            render={this.renderAuthorisedView("commissions")}
                        />,
                    !this.props.subRoles.includes(SUB_ROLES.ROOT) ? null :
                        <Route
                            key="add-commission"
                            exact
                            path="/add-commission"
                            render={this.renderAuthorisedView("add-commission")}
                        />,
                    !this.props.subRoles.includes(SUB_ROLES.ROOT) ? null :
                        <Route
                            key="edit-commission"
                            exact
                            path="/edit-commission"
                            render={this.renderAuthorisedView("edit-commission")}
                        />,
                    !this.props.subRoles.includes(SUB_ROLES.ROOT) && !this.props.subRoles.includes(SUB_ROLES.FA) ? null :
                        <Route
                            key="due-payments"
                            exact
                            path="/due-payments"
                            render={this.renderAuthorisedView("due-payments")}
                        />,
                    !this.props.subRoles.includes(SUB_ROLES.ROOT) && !this.props.subRoles.includes(SUB_ROLES.FA) ? null :
                        <Route
                            key="payments-history"
                            exact
                            path="/payments-history"
                            render={this.renderAuthorisedView("payments-history")}
                        />,
                    !this.props.subRoles.includes(SUB_ROLES.ROOT) && !this.props.subRoles.includes(SUB_ROLES.PA) ? null :
                      <Route
                        key="validated-domains"
                        exact
                        path="/validated-domains"
                        render={this.renderAuthorisedView("validated-domains")}
                      />,
                    ...this.getCommonRoutes()
                ];

            case ROLES.EMPLOYEE:
                switch (this.props.subRole) {
                    case NO_SUB_ROLES:
                        return [
                            ...this.getCommonRoutes()
                        ];

                    case SUB_ROLES.ANCHOR:
                        return [
                            <Route
                                key="organization-staff"
                                exact
                                path="/organization-staff"
                                render={this.renderAuthorisedView("organization-staff")}
                            />,
                            (!_.isNil(this.props.orgPermissions) && this.props.orgPermissions.hasIVs) ?
                                <Route
                                    key="accreditation-group"
                                    exact
                                    path="/accreditation-group"
                                    render={this.renderAuthorisedView("accreditation-group")}
                                /> : null,
                            <Route
                                key="payment"
                                exact
                                path="/payment"
                                render={this.renderAuthorisedView("payment")}
                            />,
                            <Route
                                key="department"
                                exact
                                path="/department"
                                render={this.renderAuthorisedView("department")}
                            />,
                            <Route
                                key="org-settings"
                                exact
                                path="/org-settings"
                                render={this.renderAuthorisedView("org-settings")}
                            />,
                            (!_.isNil(this.props.orgPermissions) && this.props.orgPermissions.hasIVs) ?
                                <Route
                                    key="accreditation-requests-by-group"
                                    exact
                                    path="/accreditation-requests-by-group"
                                    render={this.renderAuthorisedView("accreditation-requests-by-group")}
                                /> : null,
                            <Route
                                key="groups-management"
                                exact
                                path="/groups-management"
                                render={this.renderAuthorisedView("groups-management")}
                            />,
                            (!_.isNil(this.props.orgPermissions) && this.props.orgPermissions.hasIVs) ?
                                <Route
                                    key="security"
                                    exact
                                    path="/security"
                                    render={this.renderAuthorisedView("security")}
                                /> : null,
                            ...this.getCommonRoutes()
                        ];

                    case SUB_ROLES.INSERTER:
                        return [
                            <Route
                                key="insert-accreditation"
                                exact
                                path="/insert-accreditation"
                                render={this.renderAuthorisedView("insert-accreditation")}
                            />,
                            <Route
                                key="review-accreditations"
                                exact
                                path="/review-accreditations"
                                render={this.renderAuthorisedView("review-accreditations")}
                            />,
                            <Route
                                key="review-accreditation/validator"
                                exact
                                path="/review-accreditation/validator"
                                render={this.renderAuthorisedView("review-accreditation-rejected-by-validator")}
                            />,
                            <Route
                                key="review-accreditation/applicant"
                                exact
                                path="/review-accreditation/applicant"
                                render={this.renderAuthorisedView("review-accreditation-rejected-by-applicant")}
                            />,
                            <Route
                                key="bulk-accreditations-upload"
                                exact
                                path="/bulk-accreditations-upload"
                                render={this.renderAuthorisedView("bulk-accreditations-upload")}
                            />,
                            <Route
                                key="bulk-accreditations-upload-format-details"
                                exact
                                path="/bulk-accreditations-upload/format-details"
                                render={this.renderAuthorisedView("bulk-accreditations-upload-format-details")}
                            />,
                            <Route
                                key="pending-accreditation-requests"
                                exact
                                path="/pending-accreditation-requests"
                                render={this.renderAuthorisedView("pending-accreditation-requests")}
                            />,
                            <Route
                                key="process-accreditation-requests"
                                exact
                                path="/process-accreditation-requests"
                                render={this.renderAuthorisedView("process-accreditation-requests")}
                            />,
                            <Route
                                key="security"
                                exact
                                path="/security"
                                render={this.renderAuthorisedView("security")}
                            />,
                            ...this.getCommonRoutes()
                        ];

                    case SUB_ROLES.VALIDATOR:
                        return [
                            <Route
                                key="validate-accreditations"
                                exact
                                path="/validate-accreditations"
                                render={this.renderAuthorisedView("validate-accreditations")}
                            />,
                            <Route
                                key="validate-accreditation"
                                exact
                                path="/validate-accreditation"
                                render={this.renderAuthorisedView("validate-accreditation")}
                            />,
                            ...this.getCommonRoutes()
                        ];


                    case SUB_ROLES.HM:
                        return [
                            <Route
                                key="credentials-verification-request"
                                exact
                                path="/credentials-verification-request"
                                render={this.renderAuthorisedView("credentials-verification-request")}
                            />,
                            <Route
                                key="consent-requests"
                                exact
                                path="/consent-requests"
                                render={this.renderAuthorisedView("consent-requests")}
                            />,
                            <Route
                                key="bulk-consent-requests"
                                exact
                                path="/bulk-consent-requests"
                                render={this.renderAuthorisedView("bulk-consent-requests")}
                            />,
                            ...this.getCommonRoutes()
                        ];

                    case SUB_ROLES.BO:
                        return [
                            <Route
                                key="consent-requests"
                                exact
                                path="/consent-requests"
                                render={this.renderAuthorisedView("consent-requests")}
                            />,
                            <Route
                                key="bulk-consent-requests"
                                exact
                                path="/bulk-consent-requests"
                                render={this.renderAuthorisedView("bulk-consent-requests")}
                            />,
                            ...this.getCommonRoutes()
                        ];

                    default:
                        break;
                }
                break;

            case ROLES.APPLICANT:
                return [
                    <Route
                        key="certified-accreditations"
                        exact
                        path="/certified-accreditations"
                        render={this.renderAuthorisedView("certified-accreditations")}
                    />,
                    <Route
                        key="pending-accreditations"
                        exact
                        path="/pending-accreditations"
                        render={this.renderAuthorisedView("pending-accreditations")}
                    />,
                    <Route
                        key="validate-pending-accreditation"
                        exact
                        path="/validate-pending-accreditation"
                        render={this.renderAuthorisedView("validate-pending-accreditation")}
                    />,
                    <Route
                        key="verified-identities"
                        exact
                        path="/verified-identities"
                        render={this.renderAuthorisedView("verified-identities")}
                    />,
                    <Route
                        key="pending-consents"
                        exact
                        path="/pending-consents"
                        render={this.renderAuthorisedView("pending-consents")}
                    />,
                    <Route
                        key="approve-consent"
                        exact
                        path="/approve-consent"
                        render={this.renderAuthorisedView("approve-consent")}
                    />,
                    <Route
                        key="active-consents"
                        exact
                        path="/active-consents"
                        render={this.renderAuthorisedView("active-consents")}
                    />,
                    <Route
                        key="prior-consents"
                        exact
                        path="/prior-consents"
                        render={this.renderAuthorisedView("prior-consents")}
                    />,
                    <Route
                        key="add-prior-consent"
                        exact
                        path="/add-prior-consent"
                        render={this.renderAuthorisedView("add-prior-consent")}
                    />,
                    <Route
                        key="edit-prior-consent"
                        exact
                        path="/edit-prior-consent"
                        render={this.renderAuthorisedView("edit-prior-consent")}
                    />,
                    <Route
                        key="consents-history"
                        exact
                        path="/consents-history"
                        render={this.renderAuthorisedView("consents-history")}
                    />,
                    <Route
                        key="self-study-books"
                        exact
                        path="/self-study-books"
                        render={this.renderAuthorisedView("self-study-books")}
                    />,
                    <Route
                        key="add-self-study-book"
                        exact
                        path="/add-self-study-book"
                        render={this.renderAuthorisedView("add-self-study-book")}
                    />,
                    <Route
                        key="edit-self-study-book"
                        exact
                        path="/edit-self-study-book"
                        render={this.renderAuthorisedView("edit-self-study-book")}
                    />,
                    <Route
                        key="create-accreditation-request"
                        exact
                        path="/create-accreditation-request"
                        render={this.renderAuthorisedView("create-accreditation-request")}
                    />,
                    <Route
                        key="accreditation-requests-list"
                        exact
                        path="/accreditation-requests-list"
                        render={this.renderAuthorisedView("accreditation-requests-list")}
                    />,
                    <Route
                        key="edit-accreditation-request"
                        exact
                        path="/edit-accreditation-request"
                        render={this.renderAuthorisedView("edit-accreditation-request")}
                    />,
                    ...this.getCommonRoutes()
                ];

            default:
                break;
        }
    };

    onLogOut = () => {
        this.redirectPathAfterLogin = null;
        this.props.onLogOut();
    };

    renderLoginView = view => () => {
        if (!this.props.isAuthorised) {
            switch (view) {
                case 'login':
                    return <Login/>;
                case 'restore':
                    return <RestoreAccount/>;
                case 'company-registration':
                    return <div className="content-container">
                        <RegisterOrgByAnchor/>
                    </div>;
                case 'account-creation':
                    return <div className="content-container">
                        <CreateAccount/>
                    </div>;
                case 'resend-activation':
                    return <div className="content-container">
                        <ResendActivation/>
                    </div>;
                default:
                    return this.renderPageNotFound();
            }
        } else {
            return this.getMainPage();
        }
    };

    renderRegistrationView = ({location}) => {
        let pathParams = Utils.getParamsFromLocationSearch(location.search);
        if (_.isEmpty(pathParams)) {
            return <div className="content-container">
                <RegisterApplicant/>
            </div>;
        } else {
            return <div className="content-container">
                <RegisterInvitedApplicant location={location}/>
            </div>;
        }
    };

    renderHelpView = () => {
        return <div className="content-container">
            <HelpComponent/>
        </div>;
    };

    renderAuthorisedView = view => ({location}) => {
        if (!this.props.isAuthorised) {
            return <Redirect to="/login"/>;
        }

        if (_.isNil(view)) {
            return this.getMainPage();
        }

        switch (view) {
            case "home":
                return <HomePage/>;
            case "account":
                return (
                    <AccountManagementComponent location={location}/>
                );
            case "payment":
                return <div className="content-container">
                    <PaymentComponent/>
                </div>;
            case "organizations":
                return <div className="content-container">
                    <OrgsList/>
                </div>;
            case "validate-organizations":
                return <div className="content-container">
                    <OrgsToValidateList/>
                </div>;
            case "register-org":
                return <div className="content-container">
                    <RegisterOrg/>
                </div>;
            case "organization-staff":
                return <div className="content-container">
                    <StaffList/>
                </div>;
            case "accreditation-groups":
                return <div className="content-container">
                    {this.renderPermissionsWarning()}
                    <AccreditationGroupsList/>
                </div>;
            case "accreditation-group":
                return <div className="content-container">
                    {this.renderPermissionsWarning()}
                    <AccreditationGroupDetails location={location}/>
                </div>;
            case "department":
                return <div className="content-container">
                    <DepartmentDetails location={location}/>
                </div>;
            case "insert-accreditation":
                return <div className="content-container">
                    {this.renderPermissionsWarning()}
                    <InsertAccreditation/>
                </div>;
            case "validate-accreditations":
                return <div className="content-container">
                    {this.renderPermissionsWarning()}
                    <AccreditationsListForValidate/>
                </div>;
            case "validate-accreditation":
                return <div className="content-container">
                    {this.renderPermissionsWarning()}
                    <ValidateAccreditation/>
                </div>;
            case "review-accreditations":
                return <div className="content-container">
                    {this.renderPermissionsWarning()}
                    <RejectedAccreditationsManagementComponent/>
                </div>;
            case "review-accreditation-rejected-by-validator":
                return <div className="content-container">
                    {this.renderPermissionsWarning()}
                    <ReviewAccreditationRejectedByValidator/>
                </div>;
            case "review-accreditation-rejected-by-applicant":
                return <div className="content-container">
                    {this.renderPermissionsWarning()}
                    <ReviewAccreditationRejectedByApplicant/>
                </div>;
            case "bulk-accreditations-upload":
                return <div className="content-container">
                    <BulkJobsList/>
                </div>;
            case "bulk-accreditations-upload-format-details":
                return <div className="content-container">
                    <BulkFileFormatDetails/>
                </div>;
            case "organization":
                return <div className="content-container">
                    <OrgDetails location={location}/>
                </div>;
            case "validate-organization":
                return <div className="content-container">
                    <ValidateOrg/>
                </div>;
            case "certified-accreditations":
                return <div className="content-container">
                    <CertifiedAccreditationsList/>
                </div>;
            case "pending-accreditations":
                return <div className="content-container">
                    <PendingAccreditationsList/>
                </div>;
            case "validate-pending-accreditation":
                return <div className="content-container">
                    <ValidatePendingAccreditation location={location}/>
                </div>;
            case "verified-identities":
                return <div className="content-container">
                    <VIDsList/>
                </div>;
            case "org-settings":
                return <div className="content-container">
                    <OrgSettings/>
                </div>;
            case "consent-requests":
                return (
                    <ConsentRequestsList/>
                );
            case "credentials-verification-request":
                return <div className="content-container">
                    <CredentialsVerificationRequest/>
                </div>;
            case "pending-consents":
                return <div className="content-container">
                    <PendingConsentsList/>
                </div>;
            case "approve-consent":
                return <div className="content-container">
                    <ApproveConsentAfterRequest/>
                </div>;
            case "active-consents":
                return <div className="content-container">
                    <CurrentConsents/>
                </div>;
            case "prior-consents":
                return <div className="content-container">
                    <PriorConsentsList/>
                </div>;
            case "add-prior-consent":
                return <div className="content-container">
                    <AddPriorConsent/>
                </div>;
            case "edit-prior-consent":
                return <div className="content-container">
                    <EditPriorConsent location={location}/>
                </div>;
            case "self-study-books":
                return <div className="content-container">
                    <SelfStudyList/>
                </div>;
            case "add-self-study-book":
                return <div className="content-container">
                    <SelfStudyAdd/>
                </div>;
            case "edit-self-study-book":
                return <div className="content-container">
                    <SelfStudyEdit location={location}/>
                </div>;
            case "consents-history":
                return <div className="content-container">
                    <HistoryConsentsList/>
                </div>;
            case "bulk-consent-requests":
                return <div className="content-container">
                    <BulkConsentRequestsList/>
                </div>;
            case "create-accreditation-request":
                return <div className="content-container">
                    <CreateAccreditationRequest/>
                </div>;
            case "accreditation-requests-list":
                return <div className="content-container">
                    <AccreditationRequestsList/>
                </div>;
            case "edit-accreditation-request":
                return <div className="content-container">
                    <EditAccreditationRequest location={location}/>
                </div>;
            case "pending-accreditation-requests-by-domains":
                return <div className="content-container">
                    <PendingAccreditationRequestsByDomainsList/>
                </div>;
            case "accreditation-requests-by-group":
                return <div className="content-container">
                    <AccreditationRequestsByGroupList/>
                </div>;
            case "pending-accreditation-requests":
                return <div className="content-container">
                    <PendingAccreditationRequestsList/>
                </div>;
            case "process-accreditation-requests":
                return <div className="content-container">
                    <ProcessAccreditationRequest/>
                </div>;
            case "commissions":
                return <div className="content-container">
                    <CommissionsList/>
                </div>;
            case "add-commission":
                return <div className="content-container">
                    <AddCommission/>
                </div>;
            case "edit-commission":
                return <div className="content-container">
                    <EditCommission location={location}/>
                </div>;
            case "due-payments":
                return <div className="content-container">
                    <DuePaymentsComponent/>
                </div>;
            case "payments-history":
                return <div className="content-container">
                    <PaymentsHistoryComponent/>
                </div>;
            case "groups-management":
                if (!_.isNil(this.props.orgPermissions) && this.props.orgPermissions.hasIVs) {
                    return <div className="content-container">
                        <GroupsManagementComponent/>
                    </div>;
                }
                if (!_.isNil(this.props.orgPermissions) && !this.props.orgPermissions.hasIVs) {
                    return <div className="content-container">
                        <DepartmentsList/>
                    </div>;
                }

                return this.renderPageNotFound();
            case "security":
                if (this.props.role === ROLES.SYS_ADMIN) {
                    return <div className="content-container">
                        <AdminSecurityComponent/>
                    </div>;
                } else if (this.props.role === ROLES.EMPLOYEE) {
                    switch (this.props.subRole) {
                        case SUB_ROLES.ANCHOR:
                            return <div className="content-container">
                                <AnchorSecurityComponent/>
                            </div>;

                        case SUB_ROLES.INSERTER:
                            return <div className="content-container">
                                <InsertorSecurityComponent/>
                            </div>;

                        default:
                            break;
                    }
                }

                return this.renderPageNotFound();
            case "organizations-payments":
                return <div className="content-container">
                    <OrgsPaymentsList/>
                </div>;
            case "organization-payments":
                return <div className="content-container">
                    <OrgPaymentsDetails location={location}/>
                </div>;
            case "assistants-management":
                return <div className="content-container">
                    <AssistantsList/>
                </div>;
            case "add-assistant":
                return <div className="content-container">
                    <AddAssistantComponent/>
                </div>;
            case "business-ambassadors":
                return <div className="content-container">
                    <BusinessAmbassadorsList/>
                </div>;
            case "add-business-ambassador":
                return <div className="content-container">
                    <AddBusinessAmbassador/>
                </div>;
            case "edit-business-ambassador":
                return <div className="content-container">
                    <EditBusinessAmbassador location={location}/>
                </div>;
            case "validated-domains":
                return <div className="content-container">
                    <ValidatedDomainsList/>
                </div>;
            default:
                return this.renderPageNotFound();
        }
    };

    renderActivationView = ({location}) => {
        return <div className="content-container">
            <ActivateUserAccount location={location}/>
        </div>;
    };

    renderResetPasswordView = ({location}) => {
        return <ResetPassword location={location}/>;
    };

    renderChangeEmailView = ({location}) => {
        return <ChangeEmailFinish location={location}/>;
    };

    getMainPage = () => {
        if (!_.isNil(this.redirectPathAfterLogin) && this.props.location.pathname === "/login") {
            let redirectPath = this.redirectPathAfterLogin;
            this.redirectPathAfterLogin = null;
            return <Redirect to={redirectPath}/>;
        }

        if (_.isNil(this.props.role)) {
            return <div/>;
        }

        return this.props.location.pathname !== "/home" ? <Redirect to="/home"/> : <HomePage/>;
    };

    renderPermissionsWarning = () => {
        return null;
        // if (!_.isNil(this.props.orgPermissions) && !this.props.orgPermissions.hasIVs) {
        //     return (
        //         <Alert color="warning">{_.get(this.props.translation, 'main.limit_access_label')}</Alert>
        //     )
        // }
    };

    renderPageNotFound = () => {
        return <div className="content-container">
            <PageNotFoundComponent/>
        </div>;
    };

    handleNavbarTogglerClick = () => {
        this.setState({collapsed: !this.state.collapsed});
    };

    closeCollapse = () => {
        this.setState({collapsed: false});
    };
}

App.propTypes = {
    isAuthorised: PropTypes.bool.isRequired,
    role: PropTypes.string,
    subRole: PropTypes.string,
    userId: PropTypes.string,
    userEmail: PropTypes.string,
    orgPermissions: PropTypes.object,
    onLogOut: PropTypes.func.isRequired,
    translation: PropTypes.object,
    loadingTranslation: PropTypes.bool,
    loadingUserData: PropTypes.bool,
    loadingOrganizationData: PropTypes.bool,
    isForbidden: PropTypes.bool,
    onRefreshForbidden: PropTypes.func,
    isServerError: PropTypes.bool,
    subRoles: PropTypes.array,
    onGetOrgBalance: PropTypes.func.isRequired,
    onSetUser: PropTypes.func.isRequired
};

export default App;



// WEBPACK FOOTER //
// ./src/components/App.js